import arrowUp from "./arrow-up";
import arrowRight from "./arrow-right";
import arrowLeft from "./arrow-left";
import close from "./close";

const icons = {
  arrowUp,
  arrowRight,
  arrowLeft,
  close,
};

export default icons;
